export var DatePickerViewType;
(function (DatePickerViewType) {
    DatePickerViewType["DAY"] = "day";
    DatePickerViewType["HOURS"] = "hours";
    DatePickerViewType["MINUTES"] = "minutes";
    DatePickerViewType["MONTH"] = "month";
    DatePickerViewType["SECONDS"] = "seconds";
    DatePickerViewType["YEAR"] = "year";
})(DatePickerViewType || (DatePickerViewType = {}));
//# sourceMappingURL=DatePickerViewType.js.map